import React from 'react';
import './HomePage.css';
import tilakImage from '../../tilak2.png';

function HomePage({ setActivePage }) {
    return (
        <div className="home-page">
            <div className="welcome-section">
                <h1 className="page-title">
                    <img src={tilakImage} alt="Vaisnava Tilak" className="tilak-symbol" />
                    Welcome to Goloka Dham
                    <img src={tilakImage} alt="Vaisnava Tilak" className="tilak-symbol" />
                </h1>
                <p className="subtitle">The Supreme Spiritual Abode</p>
            </div>

            <div className="intro-card">
                <div className="intro-content">
                    <h2>Hare Krishna!</h2>
                    <p>
                        Welcome to your spiritual journey towards understanding Goloka Dham,
                        the supreme abode of Lord Sri Krishna. This website is dedicated to
                        sharing the profound wisdom of ISKCON philosophy and guiding devotees
                        on the path of bhakti (devotional service).
                    </p>
                </div>
            </div>

            <div className="features-grid">
                <div className="feature-card" onClick={() => setActivePage('what-is-goloka')}>
                    <div className="feature-icon">🌟</div>
                    <h3>Learn About Goloka Dham</h3>
                    <p>
                        Discover the glorious spiritual realm where Lord Krishna eternally
                        resides with His devotees in pure love and devotion.
                    </p>
                </div>

                <div className="feature-card" onClick={() => setActivePage('how-to-reach')}>
                    <div className="feature-icon">🛤️</div>
                    <h3>Nine Processes of Bhakti</h3>
                    <p>
                        Explore the nine processes of devotional service and learn from
                        great devotees who achieved perfection through these practices.
                    </p>
                </div>

                <div className="feature-card" onClick={() => setActivePage('quizzes')}>
                    <div className="feature-icon">📝</div>
                    <h3>Test Your Knowledge</h3>
                    <p>
                        Take quizzes on Nava Vidha Bhakti, Vaisnava Aparadh, and the
                        stages of spiritual advancement.
                    </p>
                </div>

                <div className="feature-card" onClick={() => setActivePage('calendar')}>
                    <div className="feature-icon">📅</div>
                    <h3>Vaisnava Calendar 2026</h3>
                    <p>
                        Stay updated with important Vaisnava festivals, appearance days,
                        and spiritual observances throughout the year.
                    </p>
                </div>
            </div>

            <div className="quote-section">
                <blockquote>
                    "One who is engaged in devotional service, despite the most abominable action,
                    is to be considered saintly because he is rightly situated."
                    <footer>— Bhagavad Gita 9.30</footer>
                </blockquote>
            </div>
        </div>
    );
}

export default HomePage;
